import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import { FaArrowDown, FaArrowUp, FaExchangeAlt, FaHeart } from "react-icons/fa";  // <-- added FaHeart
import "../styles/FxtNode.css";
import flat from "../images/fiat.png";
import Loader from "./Loader";

function FxtNode({ handleOpenModal }) {
    const [user, setUser] = useState(null);
    const [accountBalance, setAccountBalance] = useState(0);
    const [tradingBalance, setTradingBalance] = useState(0);
    const [loading, setLoading] = useState(true);

    const cryptoSymbols = ["BINANCE:BTCUSDT", "BINANCE:ETHUSDT", "BINANCE:SOLUSDT", "BINANCE:ADAUSDT", "BINANCE:XRPUSDT"];
    const randomSymbol = cryptoSymbols[Math.floor(Math.random() * cryptoSymbols.length)];

    useEffect(() => {
        const auth = getAuth();

        const fetchUserData = async (currentUser) => {
            try {
                const userDocRef = doc(db, "stock", currentUser.uid);
                const userDoc = await getDoc(userDocRef);

                if (userDoc.exists()) {
                    const data = userDoc.data();
                    const transactions = data.transactions || [];

                    const accBal = transactions.reduce((total, tx) => {
                        return tx.account !== "Trading"
                            ? tx.type === "credit" ? total + tx.amount : total - tx.amount
                            : total;
                    }, 0);

                    const tradeBal = transactions.reduce((total, tx) => {
                        return tx.account === "Trading"
                            ? tx.type === "credit" ? total + tx.amount : total - tx.amount
                            : total;
                    }, 0);

                    setUser({
                        name: data.fullName || "Guest",
                        email: currentUser.email,
                        profilePictureUrl: data.profilePictureUrl || currentUser.photoURL || flat,
                        role: data.role || "user"
                    });
                    setAccountBalance(accBal);
                    setTradingBalance(tradeBal);
                }
            } catch (err) {
                console.error("Error fetching user data:", err);
            }
            setLoading(false);
        };

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) fetchUserData(user);
            else {
                setUser(null);
                setAccountBalance(0);
                setTradingBalance(0);
                setLoading(false);
            }
        });

        return () => unsubscribe();
    }, []);

    if (loading) return <Loader />;
    if (!user) return <p>No user data available.</p>;

    const totalBalance = accountBalance + tradingBalance;

    const renderRoleStatus = () => {
        switch (user.role?.toLowerCase()) {
            case "admin":
                return "Admins cannot trade";
            case "user":
                return "No Trade Available";
            case "investor":
                return "A Trade is Active";
            default:
                return "Status unknown";
        }
    };

    return (
        <div className="fxt-node-container">
            {/* Info Boxes */}
            <div className="info-boxes">
                <div className="info-box">
                    <h4>Total Balance</h4>
                    <p>${totalBalance.toFixed(2)}</p>
                </div>
                <div className="info-box">
                    <h4>Investment Balance</h4>
                    <p>${accountBalance.toFixed(2)}</p>
                </div>
                <div className="info-box">
                    <h4>Trading </h4>
                    <p>${tradingBalance.toFixed(2)}</p>
                </div>
                <div className="info-box">
                    <h4>Trade Status</h4>
                    <p>{renderRoleStatus()}</p>
                </div>
            </div>

            {/* Chart and Buttons/Profile */}
            <div className="middle-section">
                <div className="crypto-graph">
                    <iframe
                        src={`https://www.tradingview.com/widgetembed/?frameElementId=tradingview_e7e3a&symbol=${randomSymbol}&interval=1D&hidesidetoolbar=1&symboledit=1&saveimage=1&toolbarbg=F1F3F6&studies=[]&theme=dark&style=1&timezone=Etc/UTC&withdateranges=1&hideideas=1&referral_id=custom`}
                        frameBorder="0"
                        title="Crypto Chart"
                        allowFullScreen
                    ></iframe>
                </div>
                <div className="action-buttons">
                    <div className="user-info">
                        <img src={user.profilePictureUrl} alt="User" />
                        <div className="user-text">
                            <h4>{user.name}</h4>
                            <p>{user.email}</p>
                        </div>
                    </div>
                    <button onClick={() => handleOpenModal("deposit")}>
                        <FaArrowDown /> Deposit
                    </button>
                    <button onClick={() => handleOpenModal("trade")}>
                        <FaExchangeAlt /> Start Trade
                    </button>
                    <button onClick={() => handleOpenModal("withdraw")}>
                        <FaArrowUp /> Withdraw
                    </button>
                    <button onClick={() => handleOpenModal("donate")}>
                        <FaHeart /> Donate to Charity
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FxtNode;
